import React from "react";
import { numberWithComma } from "../../../utility";
import Loader from "../../../components/Loader";

const PayoutSummaryFooter = ({ payout, onSave, isSaving }) => {
  return (
    <>
      <div className="flex items-center space-x-16">
        <p className="my-3 mb-6 font-bold">
          OT Hours: {payout?.total_ot_hours || "----"}
        </p>
        <p className="my-3 mb-6 font-bold">
          Total Holiday OT Hours: {payout?.total_holiday_ot_hours || "----"}
        </p>
        <p className="my-3 mb-6 font-bold">
          Total Late Hours:{" "}
          {payout?.late_duration || payout?.late_hours || "----"}
        </p>
      </div>

      <div className="flex items-center space-x-16">
        <p className="my-3 mb-6 font-bold">
          Total Variable OT Hours: {payout?.total_variable_ot_hours || "----"}
        </p>
        <p className="my-3 mb-6 font-bold">
          Variable OT Hours: {payout?.variable_ot_hours || "----"}
        </p>
        <p className="my-3 mb-6 font-bold">
          Holiday Variable OT Hours:{" "}
          {payout?.holiday_variable_ot_hours || "----"}
        </p>
      </div>

      <div className="flex items-center space-x-16">
        <p className="my-3 mb-6 font-bold">
          Net Salary Payable: ₹{" "}
          {numberWithComma(Math.round(payout?.net_salary)) || 0}
        </p>
        <p className="my-3 mb-6 font-bold">
          Net OT: ₹ {numberWithComma(Math.round(payout?.net_ot)) || 0}
        </p>
      </div>

      <div className="flex items-center space-x-16">
        <p className="my-3 mb-6 font-bold">
          Net Payable: ₹ {numberWithComma(Math.round(payout?.net_payable)) || 0}
        </p>
      </div>

      {/* Action / Save Calculations button for draft mode */}
      <div>
        {payout?.processing_status === "1" ? (
          <span className="px-4 py-2 bg-green-100 text-green-600 rounded-md font-semibold">
            Payroll Processed
          </span>
        ) : payout?.processing_status === "2" ? (
          <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
            Payroll Under Process
          </span>
        ) : payout?.processing_status === "3" ? (
          <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
            Payroll Pending
          </span>
        ) : payout?.processing_status === "4" ? (
          <span className="px-4 py-2 bg-yellow-100 text-yellow-600 rounded-md font-semibold">
            Draft in process
          </span>
        ) : (
          <button
            onClick={onSave}
            className="px-6 text-white rounded-md bg-[color:var(--color1)] py-2"
          >
            <div className="flex items-center space-x-3">
              <span>Save Calculations</span>
              {isSaving && <Loader />}
            </div>
          </button>
        )}
      </div>
    </>
  );
};

export default PayoutSummaryFooter;
